import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}

import {inject, onMounted, ref, watch, withDefaults} from 'vue'
import Dropdown, {DropdownChangeEvent} from 'primevue/dropdown'
import {AxiosStatic} from "axios";

// Define inject
type InputFieldProps = {
  id: string
  label: string
  modelValue: any
  submitted: boolean,
  vualidate: any,
  class: string
}

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectField',
  props: {
    id: null,
    label: null,
    modelValue: null,
    submitted: { type: Boolean, default: false },
    vualidate: null,
    class: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: string, label: string, modelValue: any, submitted: boolean, vualidate: any, class: string };


const axios = inject<AxiosStatic>('axios')

// Define types


// Define emits


// Define ref/reactive properties
const mv = ref<any | null>(null)
const companies = ref([])

// Define functions

function processChange(event: DropdownChangeEvent) {
  emits('update:modelValue', mv.value)
}

function loadCompanies() {
  axios?.get("/project/all").then((response) => {
    if (response.status >= 200 && response.status <= 299) {
      companies.value = response.data
    } else {
      console.error('Error loading projects', response)
    }
  })
}

// Define hooks
watch(() => props.modelValue, (current, prev) => {
  mv.value = current
})

onMounted(() => {
  loadCompanies()
  mv.value = props.modelValue
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field", props.class])
  }, [
    _createElementVNode("label", {
      for: props.id
    }, [
      _createTextVNode(_toDisplayString(props.label) + " ", 1),
      (__props.vualidate.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createVNode(_unref(Dropdown), {
      id: props.id,
      class: _normalizeClass({'p-invalid':__props.vualidate.$invalid && __props.submitted}),
      modelValue: mv.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mv).value = $event)),
      onChange: processChange,
      options: companies.value,
      optionLabel: "name",
      filter: true,
      placeholder: 'Select a ' + props.label,
      showClear: true
    }, {
      value: _withCtx((slotProps) => [
        (slotProps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(slotProps.placeholder), 1))
      ]),
      option: _withCtx((slotProps) => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
        ])
      ]),
      _: 1
    }, 8, ["id", "class", "modelValue", "options", "placeholder"]),
    (__props.vualidate.$invalid && __props.submitted)
      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(__props.vualidate.required.$message.replace('Value', props.label)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})